// extracted by mini-css-extract-plugin
export default {"base":"CbsaStats_base__2Y90v","header":"CbsaStats_header__whaK+","percentageRed":"CbsaStats_percentageRed__cp6Ye","percentageGreen":"CbsaStats_percentageGreen__v17E1"};